namespace Solovis.Reports.Parameters {

    export class AnnualizationMethodParameterControl extends Solovis.UI.BaseControl {

        private initialParameterValue: any;
        private settings: any;

        private _annualizationMethodSelector: Solovis.UI.InputControl;

        constructor(options) {
            super(options);

            this.initialParameterValue = Solovis.isNotNull(options.initialValue) ? options.initialValue : null;
            this.settings = options.settings ? options.settings : {};
        }

        public static AnnualizationMethodDefaults = {
            labels: {
                DayCount_365: "DayCount_365",
                DayCount_365_25: "DayCount_365_25",
                MonthSpan: "MonthSpan",
                MonthSpanWithPartialAsWhole: "MonthSpanWithPartialAsWhole",
                AverageDayCount: "AverageDayCount"
            }
        };

        public static getAnnualizationOptions() {
            const defaultAnnualizationMethodLabels = this.AnnualizationMethodDefaults.labels;

            let userDefinedAnnualizationMethodLabels = {};
            if ((window as any).Solovis) {
                let solovisAny = (window as any).Solovis as any;
                if (solovisAny && solovisAny.Custom && solovisAny.Custom.AnnualizationMethods) {
                    userDefinedAnnualizationMethodLabels = solovisAny.Custom.AnnualizationMethods.labels;
                }
            }

            const annualizationOptions = Object.keys(defaultAnnualizationMethodLabels).map((key) => (
                {
                    text: userDefinedAnnualizationMethodLabels[key] || defaultAnnualizationMethodLabels[key],
                    value: key
                }
            ));

            return annualizationOptions;
        }

        public static getLabel(value): string | undefined {
            if (!value) {
                return undefined;
            }
            return AnnualizationMethodParameterControl.getAnnualizationOptions().find(o => o.value === value)?.text;
        }

        public doRender() {
            let self = this;

            let activeAnnualizationMethod = this.initialParameterValue;

            let annualizationOptions = AnnualizationMethodParameterControl.getAnnualizationOptions();

            if (this.settings.allowNull === true) {
                let nullText = this.settings.nullAsDefault ? "Default" : "";
                annualizationOptions.splice(0, 0, { text: nullText, value: null });
            }
            else {
                if (!activeAnnualizationMethod) {
                    activeAnnualizationMethod = "DayCount_365";
                }
            }

            this._annualizationMethodSelector = new Solovis.UI.InputControl({
                container: this.container,
                type: "select",
                data: annualizationOptions,
                value: activeAnnualizationMethod,
                change: function () {
                    self.notifyParameterValueChanged();
                }
            });
        }

        public setParameterValue(newValue) {
            if (this._annualizationMethodSelector) {
                this._annualizationMethodSelector.value(newValue);
            }
            else {
                this.initialParameterValue = newValue;
            }
        }

        public getParameterValue() {
            if (this._annualizationMethodSelector) {
                let value = this._annualizationMethodSelector.value();
                return value;
            }
            else {
                return this.initialParameterValue;
            }
        }

        public notifyParameterValueChanged() {
            $(this).trigger("parameterValueChanged");
        }
    }

}
